import { Typography } from '@mui/material';
import { LendingServiceResponse } from '@pages/lending/types';
import clsx from 'clsx';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

interface LendingDetailsProps {
  isErrorDetail?: boolean;
  isSuccessDetail?: boolean;
  lendingData: LendingServiceResponse;
}

const LendingDetails = ({
  isErrorDetail,
  isSuccessDetail,
  lendingData,
}: LendingDetailsProps) => {
  const { t } = useTranslation();
  const {
    amount,
    currency,
    efexAdvance,
    isPayed,
    lendingRate,
    lendingType,
    ownFunds,
    percentagePayed,
    provider,
    settlementDate,
  } = lendingData;
  return (
    <div
      className={clsx(
        'bg-slate-200',
        isErrorDetail ? '!bg-red-50' : '',
        isSuccessDetail ? '!bg-teal-50' : '',
        'rounded mb-4 w-full p-5'
      )}
    >
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('clientName')}: </Typography>
        <Typography className="!font-bold !text-xl">
          {provider?.name}
        </Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('amount')}: </Typography>
        <Typography className="!font-bold !text-xl">{amount}</Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('currency')}: </Typography>
        <Typography className="!font-bold !text-xl">{currency.name}</Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('efexAdvance')}: </Typography>
        <Typography className="!font-bold !text-xl">{efexAdvance}</Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('isPayed')}: </Typography>
        <Typography className="!font-bold !text-xl">{isPayed}</Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('lendingRate')}: </Typography>
        <Typography className="!font-bold !text-xl">
          {lendingRate.name}
        </Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('lendingType')}: </Typography>
        <Typography className="!font-bold !text-xl">
          {lendingType.name}
        </Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('ownFunds')}: </Typography>
        <Typography className="!font-bold !text-xl">{ownFunds}</Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">{t('percentagePayed')}: </Typography>
        <Typography className="!font-bold !text-xl">
          {percentagePayed}
        </Typography>
      </div>
      <div className="flex justify-between py-3">
        <Typography className="!text-lg">
          {t(!settlementDate ? 'shouldArrive' : 'scheduledDate')}:
        </Typography>
        <Typography className="!font-bold !text-xl">
          {settlementDate
            ? DateTime.fromISO(settlementDate).toLocaleString(
                DateTime.DATE_SHORT
              )
            : DateTime.now().toLocaleString(DateTime.DATE_SHORT)}
        </Typography>
      </div>
    </div>
  );
};

export default LendingDetails;
